export const NON_HOST_EXPERIENCE_REFRESH_TIMEOUT = 5000;
export const OUTSIDE_MEETING_REFRESH_TIMEOUT = 30000;
export const POSTPONE_ACTION_WITH_LOADER_TIMEOUT = 300;
export const LOADING_CARD_TIMEOUT = 3000;
export const REFRESH_COOKIE_TIMEOUT = 60000;
export const PAGE_VISIBILITY_CHECK_TIMEOUT = 30000;